import { Translation } from "./translation";
import { FormBuilder, Validators } from "@angular/forms";
import { fillPriceTitleSlots } from "./experience-price-title-slots";

export namespace ExperiencePriceExtra {
  export interface PriceExtra {
    id: number;
    title_translations: Translation;
    price_cents: number;
    price_currency: string;
    position: number;
    quantity: number;
    experience_id: string;
    created_at: string;
    updated_at: string;
  }
  export function createFormGroup(fb: FormBuilder, ex?: any, accountLangIso?: string | null) {
    const fpe = fb.group({
      id: [""],
      title_translations: [{}],
      price_cents: ["", [Validators.min(0.0)]],
      price_currency: [""],
      position: [undefined],
      quantity: [0, [Validators.min(0.0)]],
      experience_id: [""],
      created_at: [""],
      updated_at: [""],
    });
    if (ex) {
      const lang = accountLangIso != null && String(accountLangIso).trim() !== "" ? accountLangIso : "en";
      const patch: Record<string, unknown> = {
        id: ex.id,
        title_translations: fillPriceTitleSlots(ex, lang),
        price_cents: ex.priceCents,
        price_currency: ex.priceCurrency,
        position: ex.position,
        quantity: ex.quantity || 0,
        experience_id: ex.experienceId,
        created_at: ex.createdAt,
        updated_at: ex.updatedAt,
      };
      fpe.patchValue(patch);
    }
    return fpe;
  }
}

export type ExperiencePriceExtra = ExperiencePriceExtra.PriceExtra;
